import ActionItemRegistry from './registry';

ActionItemRegistry.register({
    itemType: 
    [
        "bank-account-updated",
        "employer-name-address-updated",
        "participant-terminated",
        "account-terminated",
        "account-link",
        "employer-document-uploaded",
        "employer-finance-options-updated"
    ],
    buttons: "Done",
    component: "NotificationActionItem",
});


ActionItemRegistry.register({
    itemType: 
    [
        "account-link"
    ],
    buttons: "Done",
    component: "AccountLinkActionItem",
});



// WEBPACK FOOTER //
// ./src/action-items/types/notification-action-items.js